'use client';

import { useEffect, useRef, useState, type FC, type ReactNode } from 'react';
import { Button } from '../../../components/ui/Button';
import { BottomSheet } from '../../../components/ui/BottomSheet';
import { FaSlidersH } from '../../../components/icons';

interface WikiFiltersRowProps {
  tabs: ReactNode;
  label: string;
  closeLabel: string;
  count: number;
  children: ReactNode;
}

// WHY: на телефоне вкладки категорий и кнопка фильтров в одной строке, форма открывается в шторке только по нажатию — сетка остаётся на месте, кнопки шторки не прячутся под таб-баром
export const WikiFiltersRow: FC<WikiFiltersRowProps> = ({ tabs, label, closeLabel, count, children }) => {
  const [open, setOpen] = useState(false);
  const tabsRef = useRef<HTMLDivElement>(null);

  // WHY: строка вкладок уже экрана — выбранная категория иначе прячется за кнопкой фильтров
  useEffect(() => {
    const current = tabsRef.current?.querySelector<HTMLElement>('[aria-current="page"]');
    const scroller = current?.closest('nav');
    if (!current || !scroller) return;
    const tab = current.getBoundingClientRect();
    const box = scroller.getBoundingClientRect();
    scroller.scrollBy({ left: tab.left - box.left - (box.width - tab.width) / 2 });
  }, []);

  return (
    <div className="flex items-center gap-2">
      <div ref={tabsRef} className="min-w-0 flex-1">
        {tabs}
      </div>
      <Button
        type="button"
        variant="tertiary"
        size="m"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
        className="h-11 shrink-0 gap-1.5 px-3.5 font-semibold lg:hidden"
      >
        <FaSlidersH aria-hidden size={14} className="text-label-secondary" />
        {label}
        {count > 0 && <span className="rounded-full bg-accent-blue px-2 text-[13px] font-semibold leading-[20px] text-white">{count}</span>}
      </Button>
      <BottomSheet isOpen={open} onClose={() => setOpen(false)} title={label} closeAriaLabel={closeLabel} heightClass="h-[88dvh]" bodyClassName="pt-1">
        {/* WHY: форма уходит обычным GET-переходом на новый адрес — шторку закрываем сразу, не дожидаясь новой страницы */}
        <div onSubmit={() => setOpen(false)} className="flex min-h-full flex-col">
          {children}
        </div>
      </BottomSheet>
    </div>
  );
};
